var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1E5EA"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355.984,456.128h-200c-6.6,0-12-5.4-12-12v-376c0-6.6,5.4-12,12-12h200c6.6,0,12,5.4,12,12v376 C367.984,450.728,362.584,456.128,355.984,456.128z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.984,
    y: 88.16,
    width: 200,
    height: 320
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M279.776,76.128h-48c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4l0,0 C283.776,74.328,281.976,76.128,279.776,76.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M279.984,432.128h-48c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4l0,0 C283.984,430.328,282.184,432.128,279.984,432.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 116.712,
    style: {
      fill: "#8AD5DD"
    },
    width: 152,
    height: 77.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 230.952,
    style: {
      fill: "#8AD5DD"
    },
    width: 152,
    height: 8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 257.44,
    style: {
      fill: "#FFFFFF"
    },
    width: 122.04,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 283.952,
    style: {
      fill: "#8AD5DD"
    },
    width: 152,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 310.448,
    style: {
      fill: "#FFFFFF"
    },
    width: 122.04,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 336.96,
    style: {
      fill: "#8AD5DD"
    },
    width: 152,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 363.44,
    style: {
      fill: "#FFFFFF"
    },
    width: 122.04,
    height: 8
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.766b20a734ebb3c5150c006d9cf36d87.svg";
export { ForwardRef as ReactComponent };